<template>
  <section>
<!--    <Navigation></Navigation>-->
  </section>
</template>

<script>

  import Navigation from "@/components/Layout/Header/Navigation"

  export default {
    components: {Navigation},
    name: "Header",
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>
